export const servicesStatic = {
  main_scroll: {
    title_ua: 'Забронювати пробний урок',
    title_ru: 'Забронировать пробный урок',
  },
  crumbs_nav: [
    { title_ua: 'Головна', title_ru: 'Главная', link: '/' },
    // { title_ua: 'Послуги', title_ru: 'Услуги', link: '/services/' },
  ],
};
